import constructLocalEntity from 'src/utils/vuexModuleConstructor/constructLocalEntity';
import { isInteger, hideWhenDisplaying, hideWhenCreatingAndEditing, editable } from 'src/types/columnFlags';
const controlledActions = {
    create: [492],
    fetch: [493],
    update: [494],
    delete: [495],
    downloadList: [493],
    uploadList: [-1]
};
const columns = (state, getters, rootState, rootGetters) => {
    return [
        { name: 'id', style: 'width:80px', isInteger, hideWhenDisplaying, hideWhenCreatingAndEditing },
        { name: 'controlled_action_group_id', editable, references: 'controlled_actions.controlled_action_groups' },
        { name: 'app_id', editable, references: 'apps.apps' },
        { name: 'tenant_id', editable, references: 'orgs.orgs' }
    ];
};
const localEntity = constructLocalEntity({
    // @ts-ignore
    columns,
    remoteEntityName: 'controlled_actions.cag_apps_tenants_rel',
    apiVersion: 1,
    controlledActions,
    pageTitle: 'Controlled action groups to Apps, Tenants rel'
});
export default localEntity;
